
export const bootstrapper = (modules) => {
    Object.entries(modules).forEach(([name, Module]) => {
        // Find dom element
        const domNodes = document.querySelectorAll(`[data-module=${name}]`);

        // Bootstrap dom node if it exists
        if (domNodes.length) {
            domNodes.forEach((domNode) => {
                new Module(domNode);
            });
        }
    });
};

export const asyncBootstrapper = (modules) => {
    Object.entries(modules).forEach(([name, module]) => {
        // Find dom element
        const domNodes = document.querySelectorAll(`[data-module=${name}]`);

        // Bootstrap dom node if it exists
        if (!!domNodes.length) {
            domNodes.forEach(async (domNode) => {
                const Module = await module();
                new Module(domNode);
            });
        }
    });
};
